module.exports = __webpack_public_path__ + "img/gongzhonghao.c77e6e1a.png";